
angular.module('bmsApp.training').controller('TrainingIndexCtrl', [
	'$scope',
	'$log',
	'$modal',
	'notify',
	function (
		$scope,
		$log,
		$modal,
		notify) {

		$scope.$on('trainingModalSelected', function (event, args) {
			if (args.name === 'trainingProvider') {
				$scope.trainingProviderModalForm();
			}
			else if (args.name === 'trainingCourse') {
				$scope.trainingCourseModalForm();
			}
			else {
				$log.error('Invalid training modal selected');
			}
		});

		$scope.trainingProviderModalForm = function () {

			var training_provider = {};

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/employee/training/templates/TrainingProviderModalForm.html',
				controller: 'TrainingProviderModalFormCtrl',
				size: 'lg',
				scope: $scope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					training_provider: function () {
						return angular.copy(training_provider); // copy the object so we don't update the original before validation, etc.
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					angular.extend(training_provider, result.training_provider); // re-merge the (hopefully valid) copied object back into the original
					var message;
					switch (result.action) {
						case 'create':
							message = 'Training provider created successfully';
							break;
						case 'update':
							message = 'Training provider updated successfully';
							break;
						case 'delete':
							message = 'Training provider deleted successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
				}
				else {
					notify({
						mesage: result.error,
						classes: 'error'
					});
				}
			}, function () {
				$log.info('Modal cancelled');
			});

		};

		$scope.trainingCourseModalForm = function () {

			var training_course = {
				type: 'internal'
			};

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/employee/training/templates/TrainingCourseModalForm.html',
				controller: 'TrainingCourseModalFormCtrl',
				size: 'lg',
				scope: $scope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					training_course: function () {
						return angular.copy(training_course); // copy the object so we don't update the original before validation, etc.
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					angular.extend(training_course, result.training_course); // re-merge the (hopefully valid) copied object back into the original
					var message;
					switch (result.action) {
						case 'create':
							message = 'Training course created successfully';
							break;
						case 'update':
							message = 'Training course updated successfully';
							break;
						case 'delete':
							message = 'Training course deleted successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
				}
				else {
					notify({
						mesage: result.error,
						classes: 'error'
					});
				}
			}, function () {
				$log.info('Modal cancelled');
			});

		};

	}]);
